import {GET_YOUTUBE_DATA, GET_REVIEWS, GET_BLOGGER, POST_COMMENT_BLOG, POST_REVIEW_LIKE, GET_RELATED_REVIEWS, SET_QUALITY, SET_FILTER, SET_RATE, CLEAR_FILTER, SET_PAGE, REVIEW_SHARE, SET_CATEGORY, SET_SORT } from '../actions/review/type';

const initState = {youtube: null, related_reviews: null, filterCategory: null, filterQuality: null, filterRate: 0, curPage: 1, shareResult: null, sort: "create_date", order: "desc" }
export default function(state = initState, action) {
    switch(action.type) {
        case GET_YOUTUBE_DATA: 
            return {...state, youtube: action.payload.items[0].snippet}
        case GET_REVIEWS:
            let review_youtube, total_review;
            let {blogger_review: {data, count}} = action.payload;
            if (action.payload) {
                review_youtube = data;
                total_review = count;
            }
            return {...state, review_youtube, total_review}
        case GET_BLOGGER:
            return {...state, blogger_review: action.payload}
        case POST_COMMENT_BLOG:
            return {...state, comment_blogger: action.payload}
        case POST_REVIEW_LIKE:
            return {...state, review_like: action.payload}
        case GET_RELATED_REVIEWS:
            return {...state, related_reviews: action.payload}
        case SET_QUALITY: 
            const newQuality = Object.assign([{FaceType:{}}, {FaceProblem:{}}, {BodyProblem:{}}], state.filterQuality)
            let facetype, faceproblem, bodyProblem
            const facetypeQuality = newQuality[0].FaceType
            const faceproblemQuality = newQuality[1].FaceProblem
            const bodyProblemQuality = newQuality[2].BodyProblem
            let filterMenu = Object.assign([], state.filter);
        
            if(action.payload.filter === "FaceType"){
                filterMenu.push("FaceType")
                if(action.payload.quality){
                    facetype = JSON.parse(JSON.stringify(facetypeQuality))
                    facetype[action.payload.quality] = !facetype[action.payload.quality];
                    newQuality.splice(0, 1, { FaceType: facetype })
                }
            }
            if(action.payload.filter === "FaceProblem"){
                filterMenu.push("FaceProblem")
                if(action.payload.quality){
                    faceproblem = JSON.parse(JSON.stringify(faceproblemQuality))
                    faceproblem[action.payload.quality] = !faceproblem[action.payload.quality];
                    newQuality.splice(1, 1, { FaceProblem: faceproblem })
                }
            }
            if(action.payload.filter === "BodyProblem"){
                filterMenu.push("BodyProblem")
                if(action.payload.quality){
                    bodyProblem = JSON.parse(JSON.stringify(bodyProblemQuality))
                    bodyProblem[action.payload.quality] = !bodyProblem[action.payload.quality];
                    newQuality.splice(2, 1, { BodyProblem: bodyProblem })
                }
            }
            return {...state, filterQuality: newQuality};
        case SET_SORT:
            return {...state, sort: action.payload.sort, order: action.payload.order}
        case SET_FILTER: 
            return {...state, filter: action.payload }
        case SET_RATE:
            return {...state, filterRate: action.payload}
        case SET_CATEGORY:
            return {...state, filterCategory: action.payload}
        case CLEAR_FILTER:
            return {...state, filterRate: 0, filterCategory: null, filterQuality: null}
        case SET_PAGE:
            return {...state, curPage: action.payload}
        case REVIEW_SHARE:
            return {...state, shareResult: action.payload}
        default: 
            return state;
    }
}


